import axios, { AxiosResponse } from "axios";
import { ResponceApi } from "../interfaces/Responses";
import { ScivalAutorDTO } from "../interfaces/IResearch/InvestigadorScopusDTO";
import { PublicationsResponse } from "../interfaces/ProductosDTOS/Publication";
const localBack: string = process.env.REACT_APP_BACK || '';
const APICATALOGO: string = '/api/IResearch';

export default class IResearchService {
    async GetScivalAutorActivo(token: any, id: number): Promise<ResponceApi<ScivalAutorDTO>> {
        const response1: AxiosResponse<ResponceApi<ScivalAutorDTO>> = await axios.get(localBack + APICATALOGO + '/GetScivalAuthorActivo/' + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
        //console.log(response1.data);        
        return response1.data;
    }

    async GetMyPublicationsByScopusId(scopusid: string, titulo?: string, page: number = 1,pageSize: number = 25): Promise<ResponceApi<PublicationsResponse>> {

        const params: any = {
            page,
            pageSize
        };

        if (titulo) {
            params.titulo = titulo;
        }

        const response1: AxiosResponse<ResponceApi<PublicationsResponse>> = await axios.get(`https://wssaac.espol.edu.ec/investigacion${APICATALOGO}/GetMyPublicationsByScopusId/${scopusid}`,

            {
                params,
                headers: {
                    "Content-type": "application/json",
                },
            }
        );

        return response1.data;
    }
}